import { Backdrop, Box, Button, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";
import { formatPrice } from "../../../utils";

const ViewLoanModal = ({ open,
    handleClose,
    loan }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '80%' : '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 1 : 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        {/* title */}
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {t('loanInfo')}
                        </Typography>
                        <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                    </Box>

                    {/* info text */}
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('user')}: <span style={{ fontWeight: 'bold' }}>{loan.user && loan.user.name}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('branch')}: <span style={{ fontWeight: 'bold' }}>{loan.branch && loan.branch.name}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('customerType')}: <span style={{ fontWeight: 'bold' }}>{t(loan.userType)}</span>
                    </Typography>

                    {
                        loan.userType === 'page' ?
                            <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('page')}: <span style={{ fontWeight: 'bold' }}>{loan.page && loan.page.name}</span>
                            </Typography>
                            : <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('driver')}: <span style={{ fontWeight: 'bold' }}>{loan.driver && loan.driver.name}</span>
                            </Typography>
                    }

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('type')}: <span style={{
                            fontWeight: 'bold',
                            color: loan.type === 'deposit' ? theme.palette.green.box : theme.palette.red.box,
                        }}>{loan.type === 'withdraw' ? t('takeMoney') : t('giveMoney')}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('amount')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(loan.amount)}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('userWallet')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(loan.userWallet)}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('date')}: <span style={{ fontWeight: 'bold' }}>{loan.date}</span>
                    </Typography>

                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('note')}: <span style={{ fontWeight: 'bold' }}>{loan.note}</span>
                    </Typography>


                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        mt: 2
                    }}>
                        {/* close */}
                        <Button
                            variant="outlined"
                            color="primary"
                            sx={{ textTransform: 'none', width: 140, height: 40 }}
                            onClick={handleClose}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('close')}</p>
                                <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                            </Box>
                        </Button>

                        <Box width={20}></Box>

                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewLoanModal;
